module.exports = __webpack_public_path__ + "img/pitney-bowes-brasil.8b3c46a7.png";